import { createReduxActionTypes } from '../../../utils/actionFactory';
import Optional from '../../../utils/optional';

const OPEN_EDIT_CDR_HOOK = 'OPEN_EDIT_CDR_HOOK';
const RESET_EDIT_CDR_HOOK = 'RESET_EDIT_CDR_HOOK';

export const actionTypes = createReduxActionTypes('EDIT_CDR_HOOK', [
  OPEN_EDIT_CDR_HOOK,
  RESET_EDIT_CDR_HOOK
]);

const DEFAULT_STATE = {
  open: false,
  isEdit: false,
  cdrHook: {}
};

export const reducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case actionTypes[OPEN_EDIT_CDR_HOOK]: {
      const { isEdit, cdrHook } = action;
      return {
        ...state,
        open: true,
        isEdit: Optional(isEdit).or(false),
        cdrHook: Optional(cdrHook).or({})
      };
    }
    case actionTypes[RESET_EDIT_CDR_HOOK]: {
      return { ...DEFAULT_STATE };
    }
    default:
      return state;
  }
};

export const actions = {
  openEditCdrHook: (cdrHook, isEdit) => ({
    type: actionTypes[OPEN_EDIT_CDR_HOOK],
    isEdit,
    cdrHook
  }),
  closeEditCdrHook: () => ({ type: actionTypes[RESET_EDIT_CDR_HOOK] })
};
